<template>
  <div class="app-container xmzk_z">
    <div class="mycontainer" style="margin-bottom: 10px">
      <el-form
        ref="queryForm"
        :model="listQuery"
        :inline="true"
        label-width="110px"
      >
        <el-form-item label="分公司:" prop="courseGroup">
          <el-select
            v-model="listQuery.bmbh"
            placeholder="选择分公司"
            clearable
            filterable
            size="small"
            style="width: 150px"
            class="filter-item"
          >
            <el-option
              v-for="item in bmList"
              :key="item.bmbh"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目名称:" prop="xmmc">
          <el-input
            v-model="listQuery.xmmc"
            placeholder="请输入"
            clearable
            size="small"
            style="width: 150px"
            maxlength="50"
          />
        </el-form-item>

        <el-form-item label="项目阶段:" prop="xmjd">
          <el-select
            ref="xmjd"
            v-model="listQuery.xmjd"
            placeholder="全部"
            clearable
            filterable
            size="small"
            style="width: 150px"
            class="filter-item"
          >
            <el-option
              v-for="item in xmjd"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="指标名称:" prop="zbmc">
          <el-select
            ref="zbmc"
            v-model="listQuery.zbmc"
            placeholder="全部"
            clearable
            filterable
            size="small"
            style="width: 150px"
            class="filter-item"
          >
            <el-option
              v-for="item in zbmcList"
              :key="item.value"
              :label="item.value"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="审批状态:" prop="spzt">
          <el-select
            ref="spzt"
            v-model="listQuery.spzt"
            placeholder="全部"
            clearable
            filterable
            size="small"
            style="width: 150px"
            class="filter-item"
          >
            <el-option
              v-for="item in spztList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="申请说明:" prop="sqsm">
          <el-input
            v-model="listQuery.sqsm"
            placeholder="请输入"
            clearable
            size="small"
            style="width: 150px"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="申请人:" prop="sqr">
          <el-input
            v-model="listQuery.sqr"
            placeholder="请输入"
            clearable
            size="small"
            style="width: 150px"
            maxlength="50"
          />
        </el-form-item>
        <el-form-item label="申请时间:" prop="sqsj">
          <el-date-picker
            v-model="time"
            type="daterange"
            size="small"
            style="width: 300px"
            range-separator="——"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="listQuery.createTime"
            @change="handleChangeTime"
            @keyup.enter.native="getList"
          ></el-date-picker>
        </el-form-item>

        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList"
            >搜索</el-button
          >
          <el-button
            icon="el-icon-refresh"
            size="small"
            class="filter-item"
            style="margin-left: 15px"
            @click="reset"
            >重置</el-button
          >
        </span>
      </el-form>
    </div>
    <div>
      <el-table
        :max-height="height"
        v-loading="listLoading"
        :data="list"
        fit
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
        border
      >
        <!-- <el-table-column
          label="申请id"
          prop="sqid"
          align="center"
          min-width="0px"
          class-name="small-padding fixed-width"
          :show-overflow-tooltip="true"
        >  <template slot-scope="scope">
            <span>{{ scope.row.sqid }}</span>
          </template>
        </el-table-column> -->

        <el-table-column
          label="项目阶段"
          prop="xmjd"
          align="center"
          min-width="100px"
          class-name="small-padding fixed-width"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="分公司"
          prop="bmmc"
          align="center"
          min-width="100px"
          class-name="small-padding fixed-width"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="项目名称"
          prop="xmmc"
          align="center"
          min-width="200px"
          class-name="small-padding fixed-width"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.xmmc }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="复核申请指标"
          prop="zbmc"
          :show-overflow-tooltip="true"
          min-width="200px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.zbmc }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="原结果"
          prop="yjg"
          min-width="100px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.yjg }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="申请结果"
          prop="sqjg"
          min-width="100px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.sqjg }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          label="审批状态"
          prop="spzt"
          min-width="130px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.spzt }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="申请人"
          prop="sqr"
          min-width="100px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.sqr }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="申请说明"
          prop="sqsm"
          min-width="150px"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.sqsm }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="相关材料"
          prop="xgcl"
          min-width="150px"
          align="center"
        >
          <template slot-scope="scope">
            <div class="text_btn" @click="handleViewFileList(scope.row)">
              <span style="font-weight: 700">{{ scope.row.xgcl }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="申请时间"
          prop="sqsj"
          min-width="160px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.sqsj }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          label="审批人"
          prop="spr"
          min-width="100px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.spr }}</span>
          </template>
        </el-table-column>

        <el-table-column
          :show-overflow-tooltip="true"
          label="审批时间"
          prop="spsj"
          min-width="160px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.spsj }}</span>
          </template>
        </el-table-column>

        <el-table-column
          :show-overflow-tooltip="true"
          label="复核说明"
          prop="fhsm"
          min-width="160px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.fhsm }}</span>
          </template>
        </el-table-column>

        <el-table-column
          :show-overflow-tooltip="true"
          label="撤销理由"
          prop="cancel_ly"
          min-width="160px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.cancel_ly }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          align="center"
          min-width="320px"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-dropdown
              trigger="click"
              v-if="scope.row.sfcz == 1 && scope.row.spzt == '待审核'"
            >
              <el-button
                size="mini"
                type="primary"
                @click="handlePassResult(scope.row)"
                style="width: 68px; margin-right: 10px"
                >通过</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="handleNopass(scope.row)"
                style="width: 68px; margin-right: 10px"
                >不通过</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="handleReturn(scope.row)"
                >退回</el-button
              >
            </el-dropdown>
            <el-dropdown
              trigger="click"
              v-if="
                scope.row.create_by == user.ygbh && scope.row.spzt == '待审核'
              "
            >
              <el-button
                size="mini"
                type="primary"
                @click="handleUpdate(scope.row)"
                style="width: 68px; margin-right: 10px"
                >修改</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="handleCancel(scope.row)"
                >撤销</el-button
              >
            </el-dropdown>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
    </div>

    <el-dialog
      title="复核确认"
      :visible.sync="psaaResultDialog"
      width="600px"
      :closeOnClickModal="false"
      v-if="psaaResultDialog"
      class="psaaResultDialog"
    >
      <div>
        <el-form
          ref="passResultFrom"
          :model="passResultFrom"
          label-width="120px"
          class="userManage-from"
        >
          <el-form-item label="申请处理：" prop="shzt">
            <el-tag type="success">通过</el-tag>
          </el-form-item>
          <el-form-item label="指标结果：" prop="zbjg">
            <el-tag type="danger">{{ this.mxParams.yjg }}</el-tag
            >——><el-tag type="success">{{ this.mxParams.sqjg }}</el-tag>
          </el-form-item>
          <el-form-item label="复核说明：" prop="shyj">
            <el-input
              placeholder="请输入处理说明"
              v-model="shyj"
              type="textarea"
              :autosize="{ minRows: 6, maxRows: 6 }"
              maxlength="200"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="psaaResultDialog = false">取消</el-button>
        <el-button type="primary" @click="SavepassResultForm">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="复核确认"
      :visible.sync="NopsaaResultDialog"
      width="600px"
      :closeOnClickModal="false"
      v-if="NopsaaResultDialog"
      class="NopsaaResultDialog"
    >
      <div>
        <el-form
          ref="NopassResultFrom"
          :model="NopassResultFrom"
          label-width="120px"
          class="userManage-from"
        >
          <el-form-item label="申请处理：" prop="shzt">
            <el-tag type="danger">不通过</el-tag>
          </el-form-item>
          <el-form-item label="指标结果：" prop="zbjg">
            <el-tag type="danger">维持原结果</el-tag>
          </el-form-item>
          <el-form-item label="说明：" prop="spsm">
            <el-input
              placeholder="请输入处理说明"
              v-model="spsm"
              type="textarea"
              :autosize="{ minRows: 6, maxRows: 6 }"
              maxlength="200"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="NopsaaResultDialog = false">取消</el-button>
        <el-button type="primary" @click="NopassResultForm">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="相关材料"
      :visible.sync="fileListDialog"
      width="600px"
      :closeOnClickModal="false"
      v-if="fileListDialog"
    >
      <div>
        <el-table
          :max-height="400"
          :data="xgclList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          :header-cell-style="tableHeaderColor"
          border
        >
          <el-table-column
            label="材料名称"
            align="center"
            prop="wjmc"
            min-width="200px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="操作列"
            align="center"
            prop="gxlx"
            min-width="80px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                plain
                @click="handleViewFile(scope.row)"
                >预览</el-button
              >
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="fileListDialog = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="复核编辑"
      :visible.sync="updateDialog"
      width="600px"
      :closeOnClickModal="false"
      v-if="updateDialog"
      class="updateDialog"
    >
      <div>
        <el-form
          ref="updateForm"
          :model="updateForm"
          :rules="updateRules"
          label-width="120px"
          class="userManage-from"
        >
          <div class="card apply-check-card">
            <div class="card-header">
              <div class="card-title"><div>指标信息</div></div>
            </div>
            <div class="content">
              <el-form-item label="申请id" prop="sqid" style="display: none">
                <el-input v-model="updateForm.sqid" disabled></el-input>
              </el-form-item>
              <el-form-item label="质控指标：" prop="zbmc">
                <el-input
                  v-model="updateForm.zbmc"
                  disabled
                  size="small"
                ></el-input>
              </el-form-item>
              <el-form-item label="当前结果：" prop="yjg">
                <el-input
                  v-model="updateForm.yjg"
                  disabled
                  size="small"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="card apply-check-card">
            <div class="card-header">
              <div class="card-title"><div>申请变更</div></div>
            </div>
            <div class="content">
              <el-form-item label="申请结果：" prop="sqjg">
                <el-select
                  v-model="updateForm.sqjg"
                  placeholder=""
                  clearable
                  style="width: 100%"
                  size="small"
                  class="filter-item"
                >
                  <el-option label="未开始" value="1" />
                  <el-option label="未完成" value="2" />
                  <el-option label="合格" value="3" />
                  <el-option label="不合格" value="4" />
                  <el-option label="豁免" value="5" />
                </el-select>
              </el-form-item>

              <el-form-item label="申请说明：" prop="sqsm">
                <el-input
                  placeholder="申请说明"
                  v-model="updateForm.sqsm"
                  type="textarea"
                  :autosize="{ minRows: 5, maxRows: 5 }"
                  maxlength="100"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item label=" 相关材料：" prop="file">
                <el-upload
                  class="upload-demo"
                  action="#"
                  ref="upload"
                  :headers="headers"
                  :on-change="handleChangeFiles"
                  :on-exceed="handleExceed"
                  :auto-upload="false"
                  multiple
                  :limit="fileNum"
                  :file-list="fileList"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    支持上传图片（png、jpg、bmp）、Excel文档、Word文档、Pdf文档
                  </div>
                </el-upload>
              </el-form-item>
              <!-- <el-form-item label="审批人：" prop="sprXm">
                <el-input v-model="sprXm" disabled></el-input>
              </el-form-item> -->
            </div>
          </div>
          <div class="card apply-check-card" v-if="updateForm.files.length > 0">
            <div class="card-header">
              <div class="card-title"><div>复核文件</div></div>
            </div>
            <div class="content">
              <el-table
                :data="updateForm.files"
                fit
                highlight-current-row
                :default-sort="{ prop: 'date', order: 'descending' }"
                tooltip-effect="dark"
              >
                <el-table-column
                  label="文件名称"
                  align="left"
                  prop="wjmc"
                  min-width="250px"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <el-link @click="openPreview(scope.row)" type="primary">
                      {{ scope.row.wjmc }}
                    </el-link>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  align="right"
                  min-width="100px"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <el-button type="text" @click="handledelFile(scope.row)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
                <template slot="empty">
                  <div class="nodata">
                    <img src="@/img/nodata.png" alt="" width="160" />
                    <div>暂无数据</div>
                  </div>
                </template>
              </el-table>
            </div>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateDialog = false">取消</el-button>
        <el-button type="primary" @click="handleSaveUpdate">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="复核撤销"
      :visible.sync="cancelDialog"
      width="600px"
      :closeOnClickModal="false"
      v-if="cancelDialog"
      class="cancelDialog"
    >
      <div>
        <el-form
          ref="cancelFrom"
          :rules="cancelRules"
          :model="cancelFrom"
          label-width="120px"
          class="userManage-from"
        >
          <el-form-item label="撤销理由：" prop="ly">
            <el-input
              placeholder="请输入撤销理由："
              v-model="cancelFrom.ly"
              type="textarea"
              :autosize="{ minRows: 6, maxRows: 6 }"
              maxlength="200"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog = false">取消</el-button>
        <el-button type="primary" @click="handleCancelZkfh">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="复核退回"
      :visible.sync="returnDialog"
      width="600px"
      :closeOnClickModal="false"
      v-if="returnDialog"
      class="returnDialog"
    >
      <div>
        <el-form
          ref="returnFrom"
          :rules="returnRules"
          :model="returnFrom"
          label-width="120px"
          class="userManage-from"
        >
          <el-form-item label="退回理由：" prop="ly">
            <el-input
              placeholder="请输入退回理由："
              v-model="returnFrom.ly"
              type="textarea"
              :autosize="{ minRows: 6, maxRows: 6 }"
              maxlength="200"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="returnDialog = false">取消</el-button>
        <el-button type="primary" @click="handleReturnZkfh">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>



<script>
import Pagination from "@/components/Pagination";
import {
  getFhsqglList,
  getZbmcList,
  SaveZkfhReview,
  SaveZkfhCancel,
  SaveZkfhReturn,
  getJdspr,
  delZkfhFile,
  uploadFile,
  zkfhUpdate,
  getFgsList,
  getFhwjList,
} from "@/api/xmzk";
import { getDictData } from "@/api/weekly.js";
import { formatMomentDate } from "@/utils/utils";
import { mapGetters } from "vuex";

export default {
  // 列表分页
  name: "taskType",
  components: { Pagination },

  data() {
    return {
      headers: {
        "x-token": localStorage.getItem("token"),
      },
      height: 100,
      listQuery: {
        xmmc: "",
        xmjd: "",
        zbmc: "",
        spzt: "",
        sqsm: "",
        sqr: "",
        qssj: "",
        jssj: "",
        page: 1,
        pageSize: 20,
      },
      listLoading: true,
      time: [],
      zbmcList: [],
      total: 0,
      list: [],
      xmjd: [],
      spztList: [],
      mxParams: {},

      psaaResultDialog: false,
      passResultFrom: {},
      shyj: "",
      spsm: "",
      NopsaaResultDialog: false,
      NopassResultFrom: {},
      bmList: [],
      fileListDialog: false,
      xgclList: [],

      updateDialog: false,
      checkRow: {},
      updateForm: {},
      sprXm: null,
      sprId: null,
      zkzbOption: [],
      fileNum: 5,
      updateRules: {
        sqsm: [
          { required: true, message: "申请说明不能为空", trigger: "change" },
        ],
        sqjg: [
          { required: true, message: "申请结果不能为空", trigger: "change" },
        ],
      },

      cancelDialog: false,
      cancelFrom: {},
      cancelRules: {
        ly: [
          { required: true, message: "撤销理由不能为空", trigger: "change" },
        ]
      },

      returnDialog: false,
      returnFrom: {},
      returnRules: {
        ly: [
          { required: true, message: "退回理由不能为空", trigger: "change" },
        ]
      },
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  created() {
    this.$store.dispatch("common/fetchUserInfoAction");

    this.getList();

    // 获取项目阶段数据
    getDictData("xmjd", 2).then((res) => {
      if (res.code == 0) {
        this.xmjd = res.data.splice(1, 4);
      }
    });

    // 获取审批状态
    getDictData("pmp_zkgl_shzt", 1).then((res) => {
      if (res.code == 0) {
        this.spztList = res.data;
      }
    });
    // 获取指标名称
    getZbmcList().then((res) => {
      if (res.code == 0) {
        this.zbmcList = res.data;
      }
    });
    getFgsList().then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
      }
    });
  },
  methods: {
    getList() {
      const params = { ...this.listQuery };
      params.bmmc = null;
      getFhsqglList(params).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
          this.total = res.count;
          this.listLoading = false;
          const docH = document.documentElement.clientHeight;
          const mycontainerH =
            document.querySelector(".mycontainer").clientHeight;
          this.height = docH - mycontainerH - 75;
        }
      });
    },

    NopassResultForm() {
      const row = this.mxParams;
      const { sqid } = row;
      if (this.spsm.length == 0) {
        this.$message.error("说明不能为空！");
        return;
      }
      SaveZkfhReview({ sqid: sqid, shzt: "2", shyj: this.spsm }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.NopsaaResultDialog = false;
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    SavepassResultForm() {
      const row = this.mxParams;
      const { sqid } = row;
      if (this.shyj.length == 0) {
        this.$message.error("说明不能为空！");
        return;
      }
      SaveZkfhReview({ sqid: sqid, shzt: "1", shyj: this.shyj }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.psaaResultDialog = false;
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    handleChangeTime(value) {
      if (!value) {
        this.listQuery.qssj = "";
        this.listQuery.jssj = "";
        return;
      }
      this.listQuery.qssj = formatMomentDate(value[0]);
      this.listQuery.jssj = formatMomentDate(value[1]);
    },

    reset() {
      // 重置
      this.listQuery = {
        ...this.listQuery,
        ...{
          xmmc: null,
          xmjd: null,
          zbmc: null,
          spzt: null,
          sqsm: null,
          sqr: null,
          qssj: null,
          jssj: null,
        },
      };
      this.time = [];
    },
    // 通过
    handlePassResult(row) {
      this.psaaResultDialog = true;
      this.passResultFrom = {};
      this.mxParams = row;
      this.shyj = "";
      // this.SavepassResultForm(row);
    },

    // 不通过
    handleNopass(row) {
      this.NopsaaResultDialog = true;
      this.NopassResultFrom = {};
      this.mxParams = row;
      this.spsm = "";
    },

    // 撤销
    handleCancel(row) {
      this.cancelDialog = true;
      this.cancelFrom = {};
      this.cancelFrom.sqid = row.sqid;
    },

    // 退回
    handleReturn(row) {
      this.returnDialog = true;
      this.returnFrom = {};
      this.returnFrom.sqid = row.sqid;
    },

    // 修改
    handleUpdate(row) {
      this.updateDialog = true;
      let sqid = row.sqid;
      let zbmc = row.zbmc;
      let yjg = row.yjg;
      let sqjg = row.sqjg_val+"";
      let sqsm = row.sqsm;
      let files = [];

      getFhwjList({ sqid: row.sqid }).then((res) => {
        if (res.code == 0) {
          files = res.data;
          this.fileNum = 5-res.data.length;
        } else {
          this.$message.error(res.msg);
        }
        this.updateForm = { sqid, zbmc, yjg, sqjg, sqsm, files };
      });
      console.log(this.updateForm);
      // getJdspr({ zbid: row.zbid }).then((res) => {
      //   if (res.code == 0) {
      //     this.sprXm = res.data?.xm;
      //     this.sprId = res.data?.jdspr;
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // });
    },

    handleChangeFiles(file, fileList) {
      //验证上传文件的格式
      const suffixReg = /(pdf|ppt|pptx|docx|doc|png|jpg|bmp|xls|xlsx)$/;
      const point = file.name.lastIndexOf(".");
      const suffix = file.name.substr(point + 1);
      const isFile = suffixReg.test(suffix);
      if (!isFile) {
        this.$message.error("请上传正确格式的文件 !");
        fileList.pop();
        return false;
      }
      // 验证文件大小
      const isLt50M = file.size / 1024 / 1024 < 20;
      if (!isLt50M) {
        this.$message.error(file.name + "文件大小超出限制，请修改后重新上传");
        return false;
      }
    },
    handleExceed(file, fileList) {
      this.$message.error(
        `当前限制选择5个文件，本次选择了 ${fileList.length} 个文件，共选择了 ${
          this.updateForm.files.length + fileList.length
        } 个文件`
      );
    },
    openPreview(row) {
      const url = row.previewurl;
      window.open(url);
    },

    // 删除附件材料
    handledelFile(row) {
      let sqid = this.updateForm.sqid;
      let wjid = row.wjid;

      delZkfhFile({ sqid, wjid }).then((res) => {
        if (res.code == 0) {
          getFhwjList({ sqid }).then((res) => {
            if (res.code == 0) {
              this.fileNum = 5-res.data.length;
              this.updateForm.files = res.data;
              this.getList();
            }
          });
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleSaveUpdate() {
      this.$refs["updateForm"].validate((valid) => {
        if (valid) {
          //   this.$refs.upload.submit();
          let { uploadFiles } = this.$refs.upload;
          let fileLen = uploadFiles.length;
          let form = new FormData();
          uploadFiles.forEach((item, index) => {
            form.append("files", item.raw);
          });
          form.append("db", "dn0");

          if (fileLen > 0) {
            //上传文件
            return new Promise((resolve, reject) => {
              uploadFile(form)
                .then((res) => {
                  if (res.code == 0) {
                    this.$message.success("上传成功！");
                    this.updateForm.wjid = res.data;
                    this.handleUpdateZkfh();
                  } else {
                    this.$message({
                      type: "error",
                      message: res.msg,
                      showClose: true,
                    });
                  }
                  resolve(res);
                })
                .catch((err) => {
                  reject(err);
                });
            });
          } else {
            this.updateForm.wjid = "";
            this.handleUpdateZkfh();
          }
        } else {
          //   this.$message.error("请输入表单必填字段！");
        }
      });
    },
    handleUpdateZkfh() {
      const { sqid, sqjg, sqsm, wjid } = this.updateForm;
      zkfhUpdate({ sqid, sqjg, sqsm, wjid }).then((res) => {
        if (res.code == 0) {
          this.updateDialog = false;
          this.$message.success(res.msg);
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleCancelZkfh() {
      const { sqid, ly } = this.cancelFrom;
      const lyTrim = ly.trim();
      if(!ly || !lyTrim){
        this.$message.error('撤销理由不能为空！');
        return;
      }
      SaveZkfhCancel({ sqid, ly }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.cancelDialog = false;
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    handleReturnZkfh() {
      const { sqid, ly } = this.returnFrom;
      const lyTrim = ly.trim();
      if(!ly || !lyTrim){
        this.$message.error('回退理由不能为空！');
        return;
      }
      SaveZkfhReturn({ sqid, ly }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.returnDialog = false;
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    
    handleViewFileList(row) {
      this.fileListDialog = true;
      getFhwjList({ sqid: row.sqid }).then((res) => {
        if (res.code == 0) {
          this.xgclList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleViewFile(row) {
      const url = row.previewurl;
      window.open(url, "_blank");
    },
  },
};
</script>
<style lang="less" scoped>
.apply-check-card {
  border: 1px solid #efefef;
  padding: 15px;
}
.card {
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
  box-sizing: border-box;
  .card-header {
    display: flex;
    justify-content: space-between;
    height: 22px;
    line-height: 22px;
    padding-bottom: 10px;
    border-bottom: 1px solid #efefef;
    .card-title {
      position: relative;
      font-size: 16px;
      font-weight: 700;
      > div {
        padding-left: 15px;
      }
    }
    .card-title::before {
      content: "";
      height: 100%;
      background: #036eb8;
      width: 4px;
      position: absolute;
      border-radius: 4px;
    }
    .card-more {
      color: #999;
      font-size: 13px;
      cursor: pointer;
    }
  }
}
.el-input.is-disabled .el-input__inner {
  height: 32px;
}
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  font-family: "Arial Negreta" !important;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}
.dialog-footer {
  text-align: center;
}
.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}

#save-form .el-form-item {
  margin-bottom: 20px;
}
.text_btn {
  cursor: pointer;
  color: #036eb8;
}
</style>
